import { render, staticRenderFns } from "./AllPurchaseAndSaleLine.vue?vue&type=template&id=54644b8b&scoped=true&"
import script from "./AllPurchaseAndSaleLine.vue?vue&type=script&lang=js&"
export * from "./AllPurchaseAndSaleLine.vue?vue&type=script&lang=js&"
import style0 from "./AllPurchaseAndSaleLine.vue?vue&type=style&index=0&id=54644b8b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54644b8b",
  null
  
)

export default component.exports